import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Advantages.module.scss'

import { Container, Button, Image, Dropdown } from 'react-bootstrap'

class Advantages extends React.Component {
  constructor(props) {
    super(props)

    var item = []
    props.advantages.map( ( elm, k ) => {
      if( k == 0 ) item = elm
    } )

    this.state = {
      elm: item
    }
  }

  changeElm = ( elm ) => {
    this.setState({
      elm: elm
    }, () => {
      const { changeList } = this.props
      changeList( elm?.list || [] )
    })
  }

  render() {

    const { advantages, blocks } = this.props,
    { elm } = this.state

    return (
      <section className={styles.section}>
        <Container>
          <div className={styles.title}>
            <h2 dangerouslySetInnerHTML={{__html: elm?.title}} />
            <div className={styles.title_line}></div>
          </div>
          <div className={styles.btns}>
            {advantages.map( ( lelm, k ) => {
              if(lelm?.name == elm?.name) return (
                <Button as={`div`} className={styles.btn_active} key={k} variant='light'>
                  <div className={styles.btn_icon} dangerouslySetInnerHTML={{__html: lelm?.icon}} />
                  <div className={styles.btn_name}>{lelm?.name}</div>
                </Button>
              ) 
              return (
                <Button as={`div`} onClick={() => this.changeElm( lelm )} className={styles.btn} key={k} variant='light'>
                  <div className={styles.btn_icon} dangerouslySetInnerHTML={{__html: lelm?.icon}} />
                  <div className={styles.btn_name}>{lelm?.name}</div>
                </Button>
              )
            } )}
            <div className={styles.sep}></div>
            <div className={styles.rtext}>[Преимущества окон из древесины]</div>
          </div>
          <Dropdown className={styles.dropdown}>
            <Dropdown.Toggle className={styles.dropdown_toggle} variant="primary" id="dropdown-advantages">
              <div className={styles.btn_icon} dangerouslySetInnerHTML={{__html: elm?.icon}} />
              {elm?.name}
              <svg
                width="10"
                height="5"
                viewBox="0 0 12 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.btn_icon_r}
              >
                <path d="M1 1L6 6L11 1" stroke="#fff" strokeWidth="1.5" />
              </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {advantages.map( ( lelm, k ) => (
                <Dropdown.Item onClick={() => this.changeElm( lelm )}>{lelm?.name}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          {blocks == `def` &&
            <div className={styles.blocks}>
              <div className={styles.block_left}>
                <div className={styles.b_icon} dangerouslySetInnerHTML={{__html: elm?.b1_icon}} />
                <div className={styles.b_title}>
                  <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.b1_title}} />
                  <div>[01]</div>
                </div>
                <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.b1_text}} />
              </div>
              <div className={styles.block_right}>
                <div>
                  <div className={styles.b_icon} dangerouslySetInnerHTML={{__html: elm?.b2_icon}} />
                  <div className={styles.b_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.b2_title}} />
                    <div>[02]</div>
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.b2_text}} />
                </div>
                <Image className={styles.b_image} src={elm?.image} alt={elm?.b2_title} />
              </div>
            </div>
          }
          {blocks == `single` &&
            <div className={`${styles.blocks} ${styles.blocks_single}`}>
              <div className={styles.block_left}>
                <div>
                  <div className={styles.b_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.b1_title}} />
                    <div>[01]</div>
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.b1_text}} />
                </div>
                <div className={styles.b_image_container}>
                  <Image className={styles.b_image} src={elm?.image} alt={elm?.b2_title} />
                </div>
              </div>
            </div>
          }
        </Container>
      </section>
    )
  }
}

Advantages.propTypes = {
  advantages: PropTypes.array,
  blocks: PropTypes.string,
  changeList: PropTypes.func
}

Advantages.defaultProps = {
  advantages: [],
  blocks: `def`
}

export default Advantages